<template>
  <div>
    <table
    class="table table-hover">
        <tbody>
          <tr
            @click="toTag(tag.id)"
            v-for="tag in tags"
            class="pointer">
            <td>
              <el-image
                style="width: 70px; height: 70px"
                :src="tag.cover_image_url"
                fit="contain"></el-image>
            </td>
            <td>
              <h5 class="m-b-10" :class="{'text-muted': !tag.title}">
                {{ tag.title || 'Aucun titre' }}
                <br>
                <small>
                  <i v-if="tag.scheme == 'VIDEO'" class="fa fa-television"></i>
                  <i v-if="tag.scheme == 'STORY'" class="fa fa-file-text-o"></i>
                  <span
                    :class="{'badge-success': tag.status == 'PUBLISHED', 'badge-danger': tag.status == 'DISABLED'}"
                    class="badge m-l-5 m-r-5">
                    {{ tag.status | translate }}
                  </span>
                  <span v-if="tag.authors.length > 0">
                    par
                    <span v-for="author in tag.authors">
                      {{ author.screenname }}
                    </span>
                  </span>
                  - {{ tag.created_at |  fromNowDate }}
                  <span v-if="tag.tags.length > 0">
                    -
                    <span
                      v-for="tag in tag.tags"
                      v-if="tag.scheme == 'category'"
                      class="">
                      <i v-if="tag.scheme == 'category'" class="fa fa-folder-o"></i>
                      <i v-if="tag.scheme == 'story_tag'" class="fa fa-tag"></i>
                      {{ tag.label }}
                    </span>
                  </span>
                </small>
              </h5>
            </td>
          </tr>
        </tbody>
    </table>
    <hr class="m-t-10">
    <div class="text-center">
      <el-pagination
        @size-change="setPage"
        @current-change="setPage"
        :page-size="pagination.par_page"
        :pager-count="5"
        :page-count="pagination.pages"
        :page-sizes="[8, 16, 24, 50, 100]"
        :current-page="pagination.page"
        layout="total, prev, pager, next">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'tags',
    props: {
      tags: Array,
      pagination: Object,
      toTag: { type: Function },
      setPage: { type: Function }
    },
    methods: {}
  }
</script>
<style>
</style>
